module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2ONT4f/tc-custom/9781540262219.jpg?1731986837701",
      "alt": "This image is the cover for the book LGBTQ+ Long Beach, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("LGBTQ+ Long Beach, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Long Beach, California, founded in the 1880s by conservative, pro-temperance settlers, has been known as \"American Colony,\" \"Queen of the Beaches,\" \"Iowa-By-The Sea,\" \"Home of the Pike,\" and \"Paradise for Pansies.\" This book gives a glimpse of how Long Beach went from making national headlines in 1914 for entrapping 31 gay men as \"social vagrants\" to receiving a perfect score on the Human Rights Campaign's \"Municipal Equality Index\" for issues that contribute to a positive climate for LGBTQA+ people. Over time, Long Beach changed, becoming one of the most diverse cities in California. Voters elected a lesbian to city council in 2006 and a gay mayor in 2014 who they sent to Congress in 2022. Its new main library is named in honor of its hometown lesbian heroine, Billie Jean King. Today, Long Beach has the third largest \"Pride Parade and Festival\" in California.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gerrie Schipske\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Long Beach native Gerrie Schipske is the first (and only) lesbian elected to the Long Beach Community College Board of Trustees (1992) and to the Long Beach City Council (2006 and 2010). Several of her local history books are published by Arcadia, including Rosie the River in Long Beach and Historic Cemeteries of Long Beach .")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0